export const BANANA_ICON_YELLOW = "#FFC919";
export const BUTTON_YELLOW = "#FFC919";
export const LIGHT_GREY = "#F3F3F3";
export const LIGHT_YELLOW = "#FEF6D8";
export const TEXT_BROWN = "#875811";
export const TEXT_GREY = "#AAAAAA";
export const TWITTER_BLUE = "#2A90E8";
export const DISCORD_BLUE = "#5159E9";
